import { render, staticRenderFns } from "./LvContentTab001.vue?vue&type=template&id=5ec3694a"
import script from "./LvContentTab001.vue?vue&type=script&lang=js"
export * from "./LvContentTab001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports